import { EventTrigger } from '@cobliteam/common-types';
import { SafetyEventType } from './Types';

const mapEventTriggerToSafetyEventType = (eventTrigger: string): SafetyEventType => {
  switch (eventTrigger) {
    case EventTrigger.HARSH_ACCELERATION:
      return SafetyEventType.FAST_ACCELERATION;
    case EventTrigger.HARSH_BREAKING:
      return SafetyEventType.HARD_BREAK;
    case EventTrigger.HARSH_CORNERING:
      return SafetyEventType.SPEEDY_TURN;
    case EventTrigger.COLLISION:
      return SafetyEventType.IMPACT;
    case EventTrigger.DISTRACTED_DRIVING:
      return SafetyEventType.DISTRACTED_DRIVING;
    case EventTrigger.TAILGATING:
      return SafetyEventType.TAILGATING;
    case EventTrigger.YAWN:
      return SafetyEventType.YAWN;
    case EventTrigger.EYES_CLOSED:
      return SafetyEventType.EYES_CLOSED;
    case EventTrigger.PHONE_USAGE:
      return SafetyEventType.PHONE_USAGE;
    case EventTrigger.SMOKING:
      return SafetyEventType.SMOKING;
    case EventTrigger.SOS:
      return SafetyEventType.SOS;
    default:
      return SafetyEventType.SPEEDY_TURN;
  }
};

export default mapEventTriggerToSafetyEventType;
